export const FeedbackConstants = {
	RatingErrorMessage: "Please select a rating before submitting your feedback.",
	RatingCommentsErrorMessage: "Rating comments are required for ratings of 3 stars or less.",
	ScreenshotError: "Screenshot failed",
	ScreenshotFileName: "screenshot.png",
	ScreenshotMimeType: "image/png",
	FeedbackSubmitted: "Feedback submitted.",
	RatingComments: "ratingComments",
	Improvement: "improvement",
	IssueBlocker: "issueBlocker",
	PerformanceRating: "performanceRating",
	Suggestions: "suggestions",
	FeedbackThankYouMessage: "Thank you for your feedback!",
	AppreciateMessage: "Your feedback has been submitted successfully. We appreciate your input and will use it to improve our services.",
	BackButtonLabel: "Back",
	CloseButtonLabel: "Close",
	RateExperienceLabel: "Rate your experience",
    UploadAttachmentsLabel: "Upload attachments:",
    CommentsMandatoryMessage: "* This question is required for ratings of 3 stars or less",
    ImproveExpMessage: "What are the top 1-3 things you would like to see available in MDPP to improve your experience?",
    IssueBlockerMessage: "Were there any issues &/or blockers you faced?",
    PerformanceRatingMessage: "Are you satisfied with the performance of MDPP?",
    SuggestionsMessage: "Any additional feedback/suggestions you may have?",
    IncludeScreenshotMessage: "Include screenshot of this page",
    SubmitFeedbackButtonLabel: "Submit Feedback",
    ResetFormButtonLabel: "Reset Form",
    CancelButtonLabel: "Cancel",
    FormResetAnnouncement: "The feedback form has been reset.",
    DeleteAttachmentButtonLabel: "Delete",
    AttachmentDeletedAnnouncement: "{0} file deleted"
}